import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { AgentProvider } from "../../context/AgentContext";
import { TourPackageProvider } from "../../context/TourPackageContext";
// import { useAdminContext } from "../../context/admin/AdminContext";
// import { Navigate } from "react-router-dom";

// Redirect to home
// const ReturnHome = () => {
//   const { sysAdmin } = useAdminContext();
//   if (sysAdmin.role !== "admin")
//     return (
//       <Navigate
//         replace
//         to="/"
//       />
//     );
//   else return null;
// };

export const Agent = () => {
  return (
    <AgentProvider>
      <TourPackageProvider>
        {/* <ReturnHome /> */}
        <Overview />
      </TourPackageProvider>
    </AgentProvider>
  );
};

export const AddAgent = () => {
  return (
    <AgentProvider>
      <TourPackageProvider>
        {/* <ReturnHome /> */}
        
          <Add />
        
      </TourPackageProvider>
    </AgentProvider>
  );
};

export const EditAgent = () => {
  return (
    <AgentProvider>
      <TourPackageProvider>
        {/* <ReturnHome /> */}
        
          <Edit />
        
      </TourPackageProvider>
    </AgentProvider>
  );
};
